import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=0a4fa2bd&"
import script from "./FormLabel.vue?vue&type=script&lang=js&"
export * from "./FormLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports